import formatAdapter from '../utiles/supportTextAdapter';
export default {
  computed: {
    letters: function () {
      let routeNow = this.$route.name || 'mylist'; // 默认入口为工单列表
      let letters = formatAdapter(this.$store.state.support.letters);
      return letters[routeNow];
    }, // 根据路由名，切换不同的文案内容
  },
};
